<template>
  <v-content class="pa-12">
    <!-- Nevigater -->
    <v-layout mb-12>
      <v-flex
        shrink
        d-flex
        justify-start
        align-center
        class="nevigater-link"
        @click="$router.push('/sub-meeting')"
      >
        <span>จัดการห้องประชุมย่อย</span>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <v-icon color="#3E7662">arrow_right</v-icon>
      </v-flex>
      <v-flex
        shrink
        d-flex
        justify-start
        align-center
        style="color: #3E7662;font-weight: bold;font-size: 24px;"
      >
        <span>ดูข้อมูลการประชุมย่อย</span>
      </v-flex>
    </v-layout>

    <!-- Form -->
    <v-card tile>
      <v-divider
        style="background-color: #3E7662;border-width: 30px"
      ></v-divider>
      <v-divider
        style="background-color: #544A44;border-width: 2px"
      ></v-divider>
      <v-layout px-12 py-6>
        <v-flex>
          <!-- blog 1 -->
          <v-layout>
            <v-flex pr-3 d-flex justify-end align-center xs3>
              <span style="font-weight: bold;">ชื่อการประชุม</span>
            </v-flex>
            <v-flex xs6 d-flex justify-start align-center>
              <textfield-form
                readonly
                hide-detail
                :model="form.meetingName"
                @update-data="updateData('meetingName', $event)"
              />
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>

          <!-- blog 2 -->
          <v-layout mt-8>
            <v-flex pr-3 d-flex justify-end align-center xs3>
              <span style="font-weight: bold;">การประชุมครั้งที่</span>
            </v-flex>
            <v-flex xs6 d-flex justify-start align-center>
              <v-layout>
                <v-flex mr-4 xs6 d-flex justify-start align-center>
                  <textfield-form
                    readonly
                    hide-detail
                    :model="form.meetingNumber"
                    @update-data="updateData('meetingNumber', $event)"
                  />
                </v-flex>
                <v-flex xs6 d-flex justify-end align-center>
                  <v-layout>
                    <v-flex
                      xs2
                      mr-3
                      shrink
                      d-flex
                      justify-end
                      align-center
                      style="color: black;font-weight: bold;"
                    >
                      <span><b>ปี</b></span>
                    </v-flex>
                    <v-flex d-flex align-center>
                      <textfield-form
                        readonly
                        hide-detail
                        :model="form.meetingYear"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>

          <!-- blog 3 -->
          <v-layout mt-8>
            <v-flex pr-3 d-flex justify-end align-center xs3>
              <span style="font-weight: bold;">วันที่</span>
            </v-flex>
            <v-flex xs6 d-flex justify-start align-center>
              <v-layout>
                <v-flex mr-4 xs6 d-flex justify-start align-center>
                  <textfield-form readonly hide-detail :model="meetingDate" />
                </v-flex>
                <v-flex xs6 shrink d-flex justify-end align-center>
                  <v-layout>
                    <v-flex
                      xs2
                      mr-3
                      d-flex
                      justify-end
                      align-center
                      style="color: black;font-weight: bold;"
                    >
                      <span><b>เวลา</b></span>
                    </v-flex>
                    <v-flex shrink d-flex justify-start align-center>
                      <textfield-form
                        readonly
                        hide-detail
                        :model="form.meetingTime"
                      />
                    </v-flex>
                    <v-flex shrink d-flex align-center ml-2
                      ><span><b>น.</b></span></v-flex
                    >
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-spacer></v-spacer>
          </v-layout>

          <v-layout mb-6 mt-6 px-12>
            <v-flex
              shrink
              pr-4
              style="text-align: left;"
              class="d-flex align-center"
            >
              <span style="font-weight: bold;font-size: 16px;">
                ผู้เข้าร่วมงานวิจัย</span
              >
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <div
                v-for="(reviewer, reviewerIndex) in reviewers"
                :key="'reviewer_' + reviewerIndex"
              >
                <v-layout my-1 px-12>
                  <v-flex
                    shrink
                    ml-6
                    mr-4
                    pt-2
                    class="text-end font-weight-bold"
                  >
                    <span>คนที่ {{ reviewerIndex + 1 }}.</span>
                  </v-flex>
                  <v-flex xs5 class="field-select readonlyDisabled">
                    <text-autocomplete
                      disabled
                      id="reviewer"
                      placeholder="เลือก ชื่อผู้เข้าร่วมประชุม"
                      :items="reviewerList"
                      item-text="user_name"
                      itemValue="user_id"
                      :model="reviewer.userID"
                      @update-data="
                        updateData('reviewer', $event, reviewerIndex)
                      "
                    />
                  </v-flex>
                  <v-flex ml-6 class="justify-end" style="text-align: right">
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>

          <v-layout mb-6 mt-6 px-12>
            <v-flex
              shrink
              pr-4
              style="text-align: left;"
              class="d-flex align-center"
            >
              <span style="font-weight: bold;font-size: 16px;">
                ผู้ไม่ได้เข้าประชุมเนื่องจากติดราชการ</span
              >
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <div v-for="(input, k) in reviewersNotJoin" :key="k">
                <v-layout my-1 px-12>
                  <v-flex
                    shrink
                    ml-6
                    mr-4
                    pt-2
                    class="text-end font-weight-bold"
                  >
                    <span>คนที่ {{ k + 1 }}.</span>
                  </v-flex>
                  <v-flex xs5 class="field-select readonlyDisabled">
                    <text-autocomplete
                      disabled
                      id="notJoinReviewer"
                      placeholder="เลือก ชื่อผู้เข้าร่วมประชุม"
                      :items="reviewerList"
                      item-text="user_name"
                      item-value="user_id"
                      :model="input.userID"
                      @update-data="updateData('reviewersNotJoin', $event, k)"
                    />
                  </v-flex>
                  <v-flex ml-6 class="justify-end" style="text-align: right">
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
          <!-- blog 4 -->
          <v-layout mt-6 px-12>
            <v-flex mb-2 style="text-align: left;">
              <span style="font-weight: bold;">
                สถานที่
              </span>
            </v-flex>
          </v-layout>
          <v-layout px-12>
            <v-flex>
              <textarea-form
                readonly
                :rows="2"
                :model="form.meetingPlace"
                @update-data="updateData('meetingPlace', $event)"
              ></textarea-form>
            </v-flex>
          </v-layout>

          <!-- agenda 1 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 1 </span>
              <span style="font-weight: bold;"
                >เรื่องแจ้ง โดยประธานคณะทำงาน</span
              >
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex class="table">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="20%">หมายเหตุ</th>
                      <th width="10%">ไฟล์แนบ</th>
                      <th width="10%">มติที่ประชุม</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        v-html="
                          form.firstAgenda
                            ? form.firstAgenda.replace(/\n/g, '<br>')
                            : '-'
                        "
                      ></td>
                      <td>
                        <a
                          class="filePdf"
                          target="_blank"
                          :href="form.firstAgendaFilePath"
                          >{{
                            form.firstAgendaFile ? form.firstAgendaFile : "-"
                          }}</a
                        >
                      </td>
                      <td>
                        {{ form.result1 ? form.result1 : "-" }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
          <v-layout px-12 pt-4>
            <p class="meeting-result">มติที่ประชุม:</p>
            <span class="result">{{ form.result1 ? form.result1 : "-" }}</span>
          </v-layout>
          <!-- agenda 2 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 2 </span>
              <span style="font-weight: bold;"
                >การมีผลประโยชน์ทับซ้อน (Conflict of interest)</span
              >
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex class="table">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="20%">หมายเหตุ</th>
                      <th width="10%">ไฟล์แนบ</th>
                      <th width="10%">มติที่ประชุม</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        v-html="
                          form.secondAgenda
                            ? form.secondAgenda.replace(/\n/g, '<br>')
                            : '-'
                        "
                      ></td>
                      <td>
                        <a
                          class="filePdf"
                          target="_blank"
                          :href="form.secondAgendaFilePath"
                          >{{
                            form.secondAgendaFile ? form.secondAgendaFile : "-"
                          }}</a
                        >
                      </td>
                      <td>
                        {{ form.result2 ? form.result2 : "-" }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
          <v-layout px-12 pt-4>
            <p class="meeting-result">มติที่ประชุม:</p>
            <span class="result">{{ form.result2 ? form.result2 : "-" }}</span>
          </v-layout>
          <!-- agenda 3 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 3 </span>
              <span style="font-weight: bold;"
                >เรื่องสืบเนื่องจากการประชุมครั้งที่ผ่านมา</span
              >
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="10%">รอบการประชุม</th>
                      <th width="10%">ประเภทเอกสาร</th>
                      <th width="40%">ชื่อโครงการ</th>
                      <th width="10%">ผู้รับผิดชอบ</th>
                      <th width="10%">ไฟล์แนบ</th>
                      <th width="20%">หมายเหตุ</th>
                    </tr>
                  </thead>
                  <tbody v-for="(item, i) in agenda3" :key="'agenda3_' + i">
                    <!--                  <div v-for="(item,i) in agenda3" :key="'agenda3_'+i">-->
                    <tr
                      v-for="(doc, i) in item.document"
                      :key="'document_' + i"
                    >
                      <td>
                        {{ item.meetingName ? item.meetingName : "-" }}
                      </td>
                      <td>
                        {{ doc.rfType ? doc.rfType : "-" }}
                      </td>
                      <td>
                        {{ doc.researchName ? doc.researchName : "-" }}
                      </td>
                      <td>{{ doc.reviewerName ? doc.reviewerName : "-" }}</td>
                      <td>
                        <a
                          class="filePdf"
                          target="_blank"
                          :href="doc.filePath"
                          >{{ doc.file ? doc.file : "-" }}</a
                        >
                      </td>
                      <td
                        v-html="
                          doc.description
                            ? doc.description.replace(/\n/g, '<br>')
                            : '-'
                        "
                      ></td>
                    </tr>
                    <!--                  </div>-->
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
          <v-layout px-12 pt-4>
            <p class="meeting-result">มติที่ประชุม:</p>
            <span class="result">{{ form.result3 ? form.result3 : "-" }}</span>
          </v-layout>
          <!-- agenda 4_1 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 4 </span>
              <span style="font-weight: bold;"
                >การประเมินต่อเนื่องโครงการวิจัย
              </span>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 4.1 </span>
              <span style="font-weight: bold;"
                >รายงานส่วนแก้ไขเพิ่มเติมโครงร่างการวิจัย (Protocol amendment)
              </span>
            </v-flex>
            <v-flex ml-4 class="text-left">
              <p>จำนวน {{ agenda4_1.length }} โครงการ</p>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="30%">ชื่อโครงการ</th>
                      <th width="10%">ผู้รับผิดชอบ</th>
                      <th width="10%">ไฟล์แนบ</th>
                      <th width="30%">หมายเหตุ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!--                  <div v-for="(item,i) in agenda3" :key="'agenda3_'+i">-->
                    <tr v-for="(item, i) in agenda4_1" :key="'agenda4_1_' + i">
                      <td>
                        {{ item.researchName ? item.researchName : "-" }}
                      </td>
                      <td>{{ item.reviewerName ? item.reviewerName : "-" }}</td>
                      <td>
                        <a
                          class="filePdf"
                          target="_blank"
                          :href="item.filePath"
                          >{{ item.file ? item.file : "-" }}</a
                        >
                      </td>
                      <td
                        v-html="
                          item.description
                            ? item.description.replace(/\n/g, '<br>')
                            : '-'
                        "
                      ></td>
                    </tr>
                    <!--                  </div>-->
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
          <v-layout px-12 pt-4>
            <p class="meeting-result">มติที่ประชุม:</p>
            <span class="result">{{
              form.result4_1 ? form.result4_1 : "-"
            }}</span>
          </v-layout>
          <!-- agenda 4_2_1 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 4.2 </span>
              <span style="font-weight: bold;"
                >รายงานความปลอดภัย (Safety report)
              </span>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662"
                >วาระที่ 4.2.1
              </span>
              <span style="font-weight: bold;"
                >รายงานรวบรวมเหตุการณ์ไม่พึงประสงค์นอกสถาบัน
              </span>
            </v-flex>
            <v-flex ml-4 class="text-left">
              <p>จำนวน {{ agenda4_2_1.length }} โครงการ</p>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="10%">ประเภทเอกสาร</th>
                      <th width="30%">ชื่อโครงการ</th>
                      <th width="10%">ผู้รับผิดชอบ</th>
                      <th width="10%">ไฟล์แนบ</th>
                      <th width="30%">หมายเหตุ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!--                  <div v-for="(item,i) in agenda3" :key="'agenda3_'+i">-->
                    <tr
                      v-for="(item, i) in agenda4_2_1"
                      :key="'agenda4_2_1_' + i"
                    >
                      <td>
                        {{ item.rfType ? item.rfType : "-" }}
                      </td>
                      <td>
                        {{ item.researchName ? item.researchName : "-" }}
                      </td>
                      <td>{{ item.reviewerName ? item.reviewerName : "-" }}</td>
                      <td>
                        <a
                          class="filePdf"
                          target="_blank"
                          :href="item.filePath"
                          >{{ item.file ? item.file : "-" }}</a
                        >
                      </td>
                      <td
                        v-html="
                          item.description
                            ? item.description.replace(/\n/g, '<br>')
                            : '-'
                        "
                      ></td>
                    </tr>
                    <!--                  </div>-->
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
          <v-layout px-12 pt-4>
            <p class="meeting-result">มติที่ประชุม:</p>
            <span class="result">{{
              form.result4_2_1 ? form.result4_2_1 : "-"
            }}</span>
          </v-layout>
          <!-- agenda 4_2_2 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662"
                >วาระที่ 4.2.2
              </span>
              <span style="font-weight: bold;"
                >รายงานรวบรวมเหตุการณ์ไม่พึงประสงค์ในสถาบัน
              </span>
            </v-flex>
            <v-flex ml-4 class="text-left">
              <p>จำนวน {{ agenda4_2_2.length }} โครงการ</p>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="10%">ประเภทเอกสาร</th>
                      <th width="30%">ชื่อโครงการ</th>
                      <th width="10%">ผู้รับผิดชอบ</th>
                      <th width="10%">ไฟล์แนบ</th>
                      <th width="30%">หมายเหตุ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!--                  <div v-for="(item,i) in agenda3" :key="'agenda3_'+i">-->
                    <tr
                      v-for="(item, i) in agenda4_2_2"
                      :key="'agenda4_2_2_' + i"
                    >
                      <td>
                        {{ item.rfType ? item.rfType : "-" }}
                      </td>
                      <td>
                        {{ item.researchName ? item.researchName : "-" }}
                      </td>
                      <td>{{ item.reviewerName ? item.reviewerName : "-" }}</td>
                      <td>
                        <a
                          class="filePdf"
                          target="_blank"
                          :href="item.filePath"
                          >{{ item.file ? item.file : "-" }}</a
                        >
                      </td>
                      <td
                        v-html="
                          item.description
                            ? item.description.replace(/\n/g, '<br>')
                            : '-'
                        "
                      ></td>
                    </tr>
                    <!--                  </div>-->
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
          <v-layout px-12 pt-4>
            <p class="meeting-result">มติที่ประชุม:</p>
            <span class="result">{{
              form.result4_2_2 ? form.result4_2_2 : "-"
            }}</span>
          </v-layout>
          <!-- agenda 4_3 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 4.3 </span>
              <span style="font-weight: bold;"
                >รายงานการเบี่ยงเบนหรือไม่ปฏิบัติตามโครงร่างการวิจัยที่ได้รับการรับรอง
                (Protocol deviation/violation)
              </span>
            </v-flex>
            <v-flex ml-4 class="text-left">
              <p>จำนวน {{ agenda4_3.length }} โครงการ</p>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="30%">ชื่อโครงการ</th>
                      <th width="10%">ผู้รับผิดชอบ</th>
                      <th width="10%">ไฟล์แนบ</th>
                      <th width="30%">หมายเหตุ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!--                  <div v-for="(item,i) in agenda3" :key="'agenda3_'+i">-->
                    <tr v-for="(item, i) in agenda4_3" :key="'agenda4_3_' + i">
                      <td>
                        {{ item.researchName ? item.researchName : "-" }}
                      </td>
                      <td>{{ item.reviewerName ? item.reviewerName : "-" }}</td>
                      <td>
                        <a
                          class="filePdf"
                          target="_blank"
                          :href="item.filePath"
                          >{{ item.file ? item.file : "-" }}</a
                        >
                      </td>
                      <td
                        v-html="
                          item.description
                            ? item.description.replace(/\n/g, '<br>')
                            : '-'
                        "
                      ></td>
                    </tr>
                    <!--                  </div>-->
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
          <v-layout px-12 pt-4>
            <p class="meeting-result">มติที่ประชุม:</p>
            <span class="result">{{
              form.result4_3 ? form.result4_3 : "-"
            }}</span>
          </v-layout>
          <!-- agenda 4_4_1 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662"
                >วาระที่ 4.4.1
              </span>
              <span style="font-weight: bold;">Progress </span>
            </v-flex>
            <v-flex ml-4 class="text-left">
              <p>จำนวน {{ agenda4_4_1.length }} โครงการ</p>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="30%">ชื่อโครงการ</th>
                      <th width="10%">ผู้รับผิดชอบ</th>
                      <th width="10%">ไฟล์แนบ</th>
                      <th width="30%">หมายเหตุ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, i) in agenda4_4_1"
                      :key="'agenda4_4_1_' + i"
                    >
                      <td>
                        {{ item.researchName ? item.researchName : "-" }}
                      </td>
                      <td>{{ item.reviewerName ? item.reviewerName : "-" }}</td>
                      <td>
                        <a
                          class="filePdf"
                          target="_blank"
                          :href="item.filePath"
                          >{{ item.file ? item.file : "-" }}</a
                        >
                      </td>
                      <td
                        v-html="
                          item.description
                            ? item.description.replace(/\n/g, '<br>')
                            : '-'
                        "
                      ></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
          <v-layout px-12 pt-4>
            <p class="meeting-result">มติที่ประชุม:</p>
            <span class="result">{{
              form.result4_4_1 ? form.result4_4_1 : "-"
            }}</span>
          </v-layout>
           <!-- agenda 4_4_2 -->
           <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662"
                >วาระที่ 4.4.1
              </span>
              <span style="font-weight: bold;">Final </span>
            </v-flex>
            <v-flex ml-4 class="text-left">
              <p>จำนวน {{ agenda4_4_2.length }} โครงการ</p>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="30%">ชื่อโครงการ</th>
                      <th width="10%">ผู้รับผิดชอบ</th>
                      <th width="10%">ไฟล์แนบ</th>
                      <th width="30%">หมายเหตุ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, i) in agenda4_4_2"
                      :key="'agenda4_4_2_' + i"
                    >
                      <td>
                        {{ item.researchName ? item.researchName : "-" }}
                      </td>
                      <td>{{ item.reviewerName ? item.reviewerName : "-" }}</td>
                      <td>
                        <a
                          class="filePdf"
                          target="_blank"
                          :href="item.filePath"
                          >{{ item.file ? item.file : "-" }}</a
                        >
                      </td>
                      <td
                        v-html="
                          item.description
                            ? item.description.replace(/\n/g, '<br>')
                            : '-'
                        "
                      ></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
          <v-layout px-12 pt-4>
            <p class="meeting-result">มติที่ประชุม:</p>
            <span class="result">{{
              form.result4_4_2 ? form.result4_4_2 : "-"
            }}</span>
          </v-layout>
          <!-- agenda 4_4_3 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662"
                >วาระที่ 4.4.1
              </span>
              <span style="font-weight: bold;">Terminate </span>
            </v-flex>
            <v-flex ml-4 class="text-left">
              <p>จำนวน {{ agenda4_4_3.length }} โครงการ</p>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="30%">ชื่อโครงการ</th>
                      <th width="10%">ผู้รับผิดชอบ</th>
                      <th width="10%">ไฟล์แนบ</th>
                      <th width="30%">หมายเหตุ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, i) in agenda4_4_3"
                      :key="'agenda4_4_3_' + i"
                    >
                      <td>
                        {{ item.researchName ? item.researchName : "-" }}
                      </td>
                      <td>{{ item.reviewerName ? item.reviewerName : "-" }}</td>
                      <td>
                        <a
                          class="filePdf"
                          target="_blank"
                          :href="item.filePath"
                          >{{ item.file ? item.file : "-" }}</a
                        >
                      </td>
                      <td
                        v-html="
                          item.description
                            ? item.description.replace(/\n/g, '<br>')
                            : '-'
                        "
                      ></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
          <v-layout px-12 pt-4>
            <p class="meeting-result">มติที่ประชุม:</p>
            <span class="result">{{
              form.result4_4_3 ? form.result4_4_3 : "-"
            }}</span>
          </v-layout>
          <!-- agenda 5 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 5 </span>
              <span style="font-weight: bold;"> เรื่องอื่นๆ </span>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex class="table">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="20%">หมายเหตุ</th>
                      <th width="10%">ไฟล์แนบ</th>
                      <th width="10%">มติที่ประชุม</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        v-html="
                          form.fifthAgenda
                            ? form.fifthAgenda.replace(/\n/g, '<br>')
                            : '-'
                        "
                      ></td>
                      <td>
                        <a
                          class="filePdf"
                          target="_blank"
                          :href="form.fifthAgendaFilePath"
                          >{{
                            form.fifthAgendaFile ? form.fifthAgendaFile : "-"
                          }}</a
                        >
                      </td>
                      <td>
                        {{ form.result5 ? form.result5 : "-" }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
          <v-layout px-12 pt-4>
            <p class="meeting-result">มติที่ประชุม:</p>
            <span class="result">{{ form.result5 ? form.result5 : "-" }}</span>
          </v-layout>

          <!--End Time-->
          <v-layout pa-12>
            <v-flex
              shrink
              d-flex
              mr-2
              justify-start
              align-center
              style="color: black;font-weight: bold;"
            >
              <span><b>ปิดการประชุม เวลา</b></span>
            </v-flex>
            <v-flex shrink d-flex justify-start align-center>
              <vue-timepicker
                disabled
                v-model="form.meetingEndTime"
              ></vue-timepicker>
            </v-flex>
            <v-flex shrink d-flex align-center ml-2
              ><span><b>น.</b></span></v-flex
            >
          </v-layout>
          <v-layout mt-8 px-12>
            <v-flex
              shrink
              d-flex
              justify-start
              align-center
              style="text-align: left;font-weight: bold"
            >
              <span>ผลการพิจารณาโครงร่างการวิจัย</span>
            </v-flex>
          </v-layout>
          <v-layout style="padding-left: 100px;" mt-1 v-if="form.resultPath">
            <v-flex style="text-align: left;font-size: 14px">
              <span>ไฟล์: </span>
              <v-btn
                v-if="form.resultPath"
                :href="form.resultPath"
                class="white--text ml-2"
                color="#DE7133"
                target="_blank"
              >
                <span>ดาวน์โหลด</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-divider
        class="mt-12"
        style="background-color: #544A44;border-width: 2px"
      ></v-divider>
    </v-card>

    <!-- Button -->
    <v-layout mt-12>
      <v-flex mr-8 d-flex justify-start>
        <v-btn color="#FFFFFF" @click="$router.push('/sub-meeting')">
          <span style="color: #3E7662;font-weight: bold">ย้อนกลับ</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <loading
      color="#527281"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="false"
    ></loading>
  </v-content>
</template>

<script>
import vSelect from "vue-select";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import Timeselector from "vue-timeselector";
import { mapState, mapActions } from "vuex";
import TextareaForm from "../../components/input/TextareaForm";
import DateInputForm from "../../components/input/DateInputForm";
import FileInputForm from "../../components/input/FileInputForm";
import TextfieldForm from "../../components/input/TextfieldForm";
import { VueEditor } from "vue2-editor";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextAutocomplete from "../../components/input/TextAutocomplete";

export default {
  name: "EditSubMeeting",
  components: {
    TextareaForm,
    TextfieldForm,
    VueEditor,
    DateInputForm,
    Loading,
    FileInputForm,
    Timeselector,
    VueTimepicker,
    vSelect,
    TextAutocomplete,
  },
  computed: {
    years() {
      this.year = new Date().getFullYear();
      return Array.from(
        { length: this.year - 1900 },
        (value, index) => 1901 + 543 + index
      ).reverse();
    },
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  data: () => ({
    items: [
      { id: "correspondence", name: "Correspondence" },
      { id: "rf12", name: "Amendment Protocol" },
      { id: "rf04_2", name: "SAE Report" },
      { id: "rf04_1", name: "Adverse Drug Reaction Report" },
      { id: "rf05", name: "Deviation Report" },
    ],
    isLoading: false,
    fullPage: true,
    form: {
      meetingName: "",
      meetingNumber: "",
      meetingYear: "",
      meetingDate: "",
      meetingTime: "",
      meetingPlace: "",
      firstAgenda: "",
      firstAgendaFile: "",
      secondAgenda: "",
      fifthAgenda: "",
      fifthAgendaFile: "",
      hasAgenda3: "0",
      hasAgenda4_1: "0",
      hasAgenda4_2_1: "0",
      hasAgenda4_2_2: "0",
      hasAgenda4_3: "0",
      result: "",
      result1: "",
      result2: "",
      result3: "",
      result4_1: "",
      result4_2_1: "",
      result4_2_2: "",
      result4_3: "",
      result4_4_1: "",
      result4_4_2: "",
      result4_4_3: "",
      result5: "",
      meetingEndTime: "",
    },
    reviewers: [
      {
        userID: "",
      },
    ],
    reviewersNotJoin: [
      {
        userID: "",
      },
    ],
    agenda3: [
      {
        meetingID: "",
        document: [
          {
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            rfType: "",
            reviewerName: "",
            file: null,
          },
        ],
      },
    ],
    agenda4_1: [
      {
        researchID: "",
        description: "",
        reviewers: [
          {
            userID: "",
            comment: "",
            file: "",
          },
        ],
        isApprove: "",
        file: null,
      },
    ],
    agenda4_2_1: [
      {
        researchID: "",
        description: "",
        reviewerID: "",
        isApprove: "",
        reviewerName: "",
        rfType: "",
        file: null,
      },
    ],
    agenda4_2_2: [
      {
        researchID: "",
        description: "",
        reviewerID: "",
        isApprove: "",
        reviewerName: "",
        rfType: "",
        file: null,
      },
    ],
    agenda4_3: [
      {
        researchID: "",
        description: "",
        reviewerID: "",
        isApprove: "",
        reviewerName: "",
        file: null,
      },
    ],
    agenda4_4_1: [
      {
        researchID: "",
        description: "",
        reviewerID: "",
        isApprove: "",
        reviewerName: "",
        file: null,
      },
    ],
    agenda4_4_2: [
      {
        researchID: "",
        description: "",
        reviewerID: "",
        isApprove: "",
        reviewerName: "",
        file: null,
      },
    ],
    agenda4_4_3: [
      {
        researchID: "",
        description: "",
        reviewerID: "",
        isApprove: "",
        reviewerName: "",
        file: null,
      },
    ],
    meetingDate: "",
    researchConList: [],
    research4_2_1List: [],
    research4_2_2List: [],
    researchAmendmentsList: [],
    researchAdverseEventsList: [],
    researchAdverseDrugEventsList: [],
    researchDeviationsList: [],
    reviewerList: [],
    meetingList: [],
    renderKey: 0,
  }),
  async created() {
    await this.getReviewerList();
    await this.getInitialResearch();
    await this.getMeetingList();
    await this.getSubMeet();
    await this.reRender();
    console.log("researchAdverseEventsList", this.researchAdverseEventsList);
  },

  methods: {
    async getSubMeet() {
      this.isLoading = true;
      const getSubMeet = await this.$store.dispatch(
        "Meeting/getSubMeetForView",
        this.$route.query.id
      );
      this.form.meetingName = getSubMeet.meetingName;
      this.form.meetingNumber = getSubMeet.meetingNumber;
      this.form.meetingYear = getSubMeet.meetingYear;
      this.form.meetingDate = getSubMeet.meetingDate;
      this.meetingDate = this.changeDate(getSubMeet.meetingDate);
      this.form.meetingTime = getSubMeet.meetingTime;
      this.form.meetingPlace = getSubMeet.meetingPlace;

      this.reviewers = getSubMeet.reviewers;
      this.reviewersNotJoin = getSubMeet.reviewersNotJoin;
      this.form.hasAgenda3 = getSubMeet.hasAgenda3;
      this.form.hasAgenda4_1 = getSubMeet.hasAgenda4_1;
      this.form.hasAgenda4_2_1 = getSubMeet.hasAgenda4_2_1;
      this.form.hasAgenda4_2_2 = getSubMeet.hasAgenda4_2_2;
      this.form.hasAgenda4_3 = getSubMeet.hasAgenda4_3;
      this.form.firstAgenda = getSubMeet.firstAgenda;
      this.form.firstAgendaFile = getSubMeet.firstAgendaFile;
      this.form.firstAgendaFilePath = getSubMeet.firstAgendaFilePath;
      this.form.secondAgenda = getSubMeet.secondAgenda;
      this.form.secondAgendaFile = getSubMeet.secondAgendaFile;
      this.form.secondAgendaFilePath = getSubMeet.secondAgendaFilePath;
      this.form.fifthAgenda = getSubMeet.fifthAgenda;
      this.form.fifthAgendaFile = getSubMeet.fifthAgendaFile;
      this.form.fifthAgendaFilePath = getSubMeet.fifthAgendaFilePath;
      this.form.result = getSubMeet.result;
      this.form.resultPath = getSubMeet.resultPath;
      this.form.result1 = getSubMeet.result1;
      this.form.result2 = getSubMeet.result2;
      this.form.result3 = getSubMeet.result3;
      this.form.result4_1 = getSubMeet.result4_1;
      this.form.result4_2_1 = getSubMeet.result4_2_1;
      this.form.result4_2_2 = getSubMeet.result4_2_2;
      this.form.result4_3 = getSubMeet.result4_3;
      this.form.result5 = getSubMeet.result5;
      this.form.meetingEndTime = getSubMeet.meetingEndTime;
      this.agenda3 = getSubMeet.agenda3;
      this.agenda4_1 = getSubMeet.agenda4_1;
      this.agenda4_2_1 = getSubMeet.agenda4_2_1;
      this.agenda4_2_2 = getSubMeet.agenda4_2_2;
      this.agenda4_3 = getSubMeet.agenda4_3;
      this.agenda4_4_1 = getSubMeet.agenda4_4_1;
      this.agenda4_4_2 = getSubMeet.agenda4_4_2;
      this.agenda4_4_3 = getSubMeet.agenda4_4_3;
      if (getSubMeet.agenda3)
        this.agenda3.forEach((third, index) => {
          third.document.forEach((data, i) => {
            if (typeof this.researchConList[index * 10 + i] == undefined) {
              console.log("no");
            }
            switch (data.rfType) {
              case "rf12":
                console.log("index", index);
                console.log("researchConList", this.researchConList[index]);
                this.researchConList[
                  index * 10 + i
                ] = this.researchAmendmentsList;
                // this.researchConList[index*10 + i]] = this.researchAmendmentsList;
                break;
              case "rf04_2":
                this.researchConList[
                  index * 10 + i
                ] = this.researchAdverseEventsList;
                break;
              case "rf04_1":
                this.researchConList[
                  index * 10 + i
                ] = this.researchAdverseDrugEventsList;
                break;
              case "rf05":
                this.researchConList[
                  index * 10 + i
                ] = this.researchDeviationsList;
                break;
            }
          });
        });
      if (getSubMeet.agenda4_2_1)
        this.agenda4_2_1.forEach((data, index) => {
          switch (data.rfType) {
            case "rf12":
              this.research4_2_1List[index] = this.researchAmendmentsList;
              // this.research4_2_1List[index][index] = this.researchAmendmentsList;
              break;
            case "rf04_2":
              this.research4_2_1List[index] = this.researchAdverseEventsList;
              break;
            case "rf04_1":
              this.research4_2_1List[
                index
              ] = this.researchAdverseDrugEventsList;
              break;
            case "rf05":
              this.research4_2_1List[index] = this.researchDeviationsList;
              break;
          }
        });
      if (getSubMeet.agenda4_2_2)
        this.agenda4_2_2.forEach((data, index) => {
          switch (data.rfType) {
            case "rf12":
              this.research4_2_2List[index] = this.researchAmendmentsList;
              // this.research4_2_2List[index][index] = this.researchAmendmentsList;
              break;
            case "rf04_2":
              this.research4_2_2List[index] = this.researchAdverseEventsList;
              break;
            case "rf04_1":
              this.research4_2_2List[
                index
              ] = this.researchAdverseDrugEventsList;
              break;
            case "rf05":
              this.research4_2_2List[index] = this.researchDeviationsList;
              break;
          }
        });

      this.isLoading = false;
    },
    reRender() {
      this.renderKey++;
      console.log("rerender", this.renderKey);
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);
      sub_year = parseInt(sub_year) + 543;
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    getInitialResearch() {
      this.isLoading = true;
      this.$store
        .dispatch("Research/getInitialResearchList")
        .then((res) => {
          this.isLoading = false;
          console.log("getInitialResearchList", res);
          res.amendment.forEach((data) => {
            this.researchAmendmentsList.push({
              id: data.research.id,
              name:
                data.research.researchCode + "-" + data.research.thResearchName,
              reviewerID: data.reviewerID,
              reviewerName: data.reviewer.thName,
            });
          });
          res.adverseEvent.forEach((data) => {
            this.researchAdverseEventsList.push({
              id: data.research.id,
              name:
                data.research.researchCode + "-" + data.research.thResearchName,
              reviewerID: data.reviewerID,
              reviewerName: data.reviewer.thName,
            });
          });
          res.adverseDrugEvent.forEach((data) => {
            this.researchAdverseDrugEventsList.push({
              id: data.research.id,
              name:
                data.research.researchCode + "-" + data.research.thResearchName,
              reviewerID: data.reviewerID,
              reviewerName: data.reviewer.thName,
            });
          });
          res.deviation.forEach((data) => {
            this.researchDeviationsList.push({
              id: data.research.id,
              name:
                data.research.researchCode + "-" + data.research.thResearchName,
              reviewerID: data.reviewerID,
              reviewerName: data.reviewer.thName,
            });
          });
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    getMeetingList() {
      this.$store.dispatch("Meeting/getSubMeetList").then((res) => {
        res.forEach((data) => {
          this.meetingList.push({
            id: data.id,
            name: data.meetingName + " (" + data.meetingDate + ")",
          });
        });
      });
    },
    clearRadio(name, index) {
      if (name === "hasAgenda3") {
        this.agenda3 = [
          {
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            reviewerName: "",
            rfType: "",
            file: null,
          },
        ];
      }
      if (name === "hasAgenda4_1") {
        this.agenda4_1 = [
          {
            researchID: "",
            description: "",
            reviewers: [
              {
                userID: "",
                comment: "",
                file: "",
              },
            ],
            isApprove: "",
            file: null,
          },
        ];
      }
      if (name === "hasAgenda4_2_1") {
        this.agenda4_2_1 = [
          {
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            reviewerName: "",
            rfType: "",
            file: null,
          },
        ];
      }
      if (name === "hasAgenda4_2_2") {
        this.agenda4_2_2 = [
          {
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            reviewerName: "",
            rfType: "",
            file: null,
          },
        ];
      }
      if (name === "hasAgenda4_3") {
        this.agenda4_3[index].has = [
          {
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            reviewerName: "",
            file: null,
          },
        ];
      }
    },
    getReviewerList() {
      this.isLoading = true;
      this.$store
        .dispatch("User/getReviewerList")
        .then((res) => {
          this.isLoading = false;
          res.forEach((data) => {
            this.reviewerList.push({
              user_id: data.id,
              user_name: data.thName,
            });
          });
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.readonlyDisabled {
  .v-input__slot {
    background-color: #3e7662 !important;
  }
  .theme--dark.v-input,
  .theme--dark.v-input input,
  .theme--dark.v-input textarea {
    color: #fff !important;
  }
}
</style>
<style lang="scss" scoped>
.vue__time-picker input.display-time {
  background-color: #3e7662;
  color: white;
  border: 1px solid #d2d2d2;
  width: 10em;
  height: 2.2em;
  padding: 0.3em 0.5em;
  font-size: 1em;
}
.clear-card:hover {
  cursor: pointer;
  background-color: #f5a9a9;
}
th {
  background-color: #3e7662;
  color: white !important;
  border-left: thin solid black !important;
  border-top: thin solid black !important;
  border-bottom: thin solid black !important;
}
th:last-child {
  border-right: thin solid black !important;
}
td {
  color: black !important;
  border-left: thin solid black !important;
  border-bottom: thin solid black !important;
}
td:last-child {
  border-right: thin solid black !important;
}
.filePdf {
  text-decoration: none;
  color: rgb(204, 61, 69);
}
.filePdf:hover {
  text-decoration: underline;
}
.meeting-result {
  text-decoration: underline;
  margin-right: 16px;
}
.result {
  margin-top: 4px;
}
</style>
